/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const removeTeamMembershipBodyExpectedVersionExclusiveMin = 0;
export const removeTeamMembershipBodyExpectedVersionMax = 9007199254740991;

export const RemoveTeamMembershipBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(removeTeamMembershipBodyExpectedVersionExclusiveMin)
    .max(removeTeamMembershipBodyExpectedVersionMax),
});

export type RemoveTeamMembershipBody = zod.input<typeof RemoveTeamMembershipBody>;
export type RemoveTeamMembershipBodyOutput = zod.output<typeof RemoveTeamMembershipBody>;
